export const modeExecutionData = [
    {
        code: 'DIRECTE',
        label: 'Exécution directe'
    },
    {
        code: "INDIRECTE",
        label: "Exécution indirecte"
    },
    {
        code: "PMP",
        label: "Pmp"
    }
]

export const HorizonData = [
    {
        code: "FAVORABLE",
        valeur: "Favorable"
    },
    {
        code: "DEFAVORABLE",
        valeur: "Défavorable"
    },
    {
        code: "STABLE",
        valeur: "Stable"
    }
]

export const StructureData = [
    {
        code: "CFPP",
        valeur: "Cfpp"
    },
    {
        code: "DARH",
        valeur: "Darh"
    },
    {
        code: "DCGIS",
        valeur: "Dcgis"
    },
    {
        code: "DCN",
        valeur: "Dcn"
    },
    {
        code: "DEPP",
        valeur: "Depp"
    },
    {
        code: "DFC",
        valeur: "Dfc"
    },
    {
        code: "DG",
        valeur: "Dg"
    },
    {
        code: "DM",
        valeur: "Dm"
    },
    {
        code: "DRB",
        valeur: "Drb"
    },
    {
        code: "DRT",
        valeur: "Drt"
    },
    {
        code: "DT",
        valeur: "Dt"
    },
    {
        code: "SCRE",
        valeur: "Scre"
    },
    {
        code: "SERVICE_EN_TAFF",
        valeur: "Service en taff"
    }
]

export const imputationBudgetaireData = [
    { code: "20", valeur: "20" },
    { code: "23", valeur: "23" },
    { code: "24", valeur: "24" },
    { code: "244", valeur: "244" },
    { code: "245", valeur: "245" },
    { code: "60421000", valeur: "60421000" },
    { code: "63", valeur: "63" },
]